webpackJsonp([15],{

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(611),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);


/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {
        if (!window.GLOBAL_USER_ACTIONS && localStorage.GLOBAL_USER_ACTIONS) {
            window.GLOBAL_USER_ACTIONS = JSON.parse(localStorage.GLOBAL_USER_ACTIONS);
        }
        Vue.directive("privilege", {
            bind: function bind(el, binding) {
                var actions = window.GLOBAL_USER_ACTIONS || [];
                for (var i = 0, count = actions.length; i < count; i++) {
                    if (actions[i] == binding.value) {
                        return;
                    }
                }

                el.style.display = "none";
            }
        });
    },
    reset: function reset() {
        delete window.GLOBAL_USER_ACTIONS;
        localStorage.removeItem("GLOBAL_USER_ACTIONS");
    }
});

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_router__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_auth__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_customization__ = __webpack_require__(230);









var App = function App(resolve) {
  return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(148)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Login = function Login(resolve) {
  return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(629)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Main = function Main(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(233)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Home = function Home(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(628)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Unauthorized = function Unauthorized(resolve) {
  return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(622)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NotFound = function NotFound(resolve) {
  return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(623)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var InternalServerError = function InternalServerError(resolve) {
  return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(624)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Auth = function Auth(resolve) {
  return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(625)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Authorize = function Authorize(resolve) {
  return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(626)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var IFrameContainer = function IFrameContainer(resolve) {
  return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(627)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [{
    path: '/login',
    name: 'login',
    meta: {
      keepAlive: true,
      allowAnonymous: true
    },
    component: Login
  }, {
    path: '/401',
    name: '401',
    component: Unauthorized,
    meta: {
      allowAnonymous: true
    }
  }, {
    path: '/404',
    name: '404',
    component: NotFound,
    meta: {
      allowAnonymous: true
    }
  }, {
    path: '/500',
    name: '500',
    component: InternalServerError,
    meta: {
      allowAnonymous: true
    }
  }, {
    path: '/auth/:userId/:targetUrl',
    name: 'auth',
    component: Auth,
    meta: {
      allowAnonymous: true
    }
  }, {
    path: '/authorize',
    name: 'authorize',
    component: Authorize,
    meta: {
      allowAnonymous: true
    }
  }, {
    path: '/',
    redirect: {
      name: 'home'
    },
    meta: {
      keepAlive: true
    },
    component: Main,
    children: [{
      path: 'home',
      name: 'home',
      meta: {
        keepAlive: true
      },
      component: Home
    }, {
      path: 'external/:url',
      name: 'external',
      component: IFrameContainer
    }]
  }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(generateRoutesFromModules()), [{
    path: '*',
    redirect: '/404'
  }])
});

router.beforeEach(function (to, from, next) {
  if (to.meta.allowAnonymous) {
    if (to.name === "auth" || to.name === "authorize") {
      __WEBPACK_IMPORTED_MODULE_4__plugins_auth__["a" /* default */].clearAllData();
    }

    next();
    return;
  }

  if (to.name.contains("crm__")) {
    guardCrmRoute(to, from, next);
    return;
  }

  guardRoute(to, from, next);
});

function generateRoutesFromModules() {
  return __WEBPACK_IMPORTED_MODULE_3__module_router__["a" /* default */];
}

function guardCrmRoute(to, from, next) {
  var auth = router.app.$options.store.state.auth;
  if (!auth.isLoggedIn) {
    var redirectUrl = location.origin + location.pathname + "#/authorize?redirect_url=" + encodeURIComponent(to.path);
    var data = encodeURIComponent("redirect_url=" + encodeURIComponent(redirectUrl));


    window.location.href = __WEBPACK_IMPORTED_MODULE_5__config_customization__["a" /* crmUrl */] + '/WebResources/new_/connect/authorize.html?Data=' + data;
  } else {
    next();
  }
}

function guardRoute(to, from, next) {
  var user = router.app.$options.store.state.user;
  if (user != null && user.loginType != null && user.loginType == 'sso_mscrm') {
    __WEBPACK_IMPORTED_MODULE_4__plugins_auth__["a" /* default */].logout();
    return;
  }

  var auth = router.app.$options.store.state.auth;
  if (!auth.isLoggedIn) {
    if (to.name === 'home') {
      next({
        name: 'login'
      });
    } else {
      next({
        name: 'login',
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    next();
  }
}

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins__ = __webpack_require__(302);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* state */],
    getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
    actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
    mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__,
    plugins: __WEBPACK_IMPORTED_MODULE_6__plugins__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$store = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].store = store;

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);


var STORAGE_KEY = 'PortalStorage';

var syncedData = {
    auth: {
        isLoggedIn: false,
        accessToken: null,
        refreshToken: null
    },
    user: {
        userId: null,
        userName: null,
        nickName: null,
        loginType: null,
        avatarUrl: null,
        departName: null,
        departId: null
    }
};

if (localStorage.getItem(STORAGE_KEY)) {
    syncedData = JSON.parse(localStorage.getItem(STORAGE_KEY));
}

var ui = {
    tableHeight: 0
};

var state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(syncedData, ui);

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(565)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(598),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(566)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(599),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_reset_css__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_rtportal_css__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_rtportal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_css_rtportal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_rtportal_js__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_fonts_styles_css__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_fonts_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_css_fonts_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__theme_index_css__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__theme_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__theme_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_http__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_auth__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugins_privilege__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_heartbeat__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_i18n__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config_i18n_map__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_locale_format__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_locale_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_locale_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_xlsx_table__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_xlsx_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_xlsx_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__packages__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__App__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__App__);














__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9__plugins_http__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__plugins_auth__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__plugins_privilege__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12__plugins_heartbeat__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_i18n__["a" /* default */]);



var defaultLocale = localStorage.i18nLocale;
if (defaultLocale === null || defaultLocale === undefined) {
  defaultLocale = __WEBPACK_IMPORTED_MODULE_14__config_i18n_map__["a" /* locales */][0].value;
}
var _i18n = new __WEBPACK_IMPORTED_MODULE_13_vue_i18n__["a" /* default */]({
  locale: defaultLocale,
  messages: __WEBPACK_IMPORTED_MODULE_14__config_i18n_map__["b" /* messages */] });
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n = _i18n;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.interceptors.request.use(function (config) {
  var locale = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.locale;
  if (locale !== null && locale.length > 0) {
    config.headers["Accept-Language"] = locale;
  }
  return config;
});





var formater = __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_locale_format___default()(__WEBPACK_IMPORTED_MODULE_1_vue__["default"]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_element_ui___default.a, {
  i18n: function i18n(path, options) {
    var value = _i18n.t(path);
    if (value !== null && value !== undefined) return formater(value, options);
    var array = path.split('.');
    for (var i = 0, j = array.length; i < j; i += 1) {
      var property = array[i];
      value = _i18n.t(property);
      if (i === j - 1) return formater(value, options);
      if (!value) return '';
    }
    return '';
  }
});


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_xlsx_table___default.a, {
  rABS: true
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19__packages__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.debug = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.devtools = true;



new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  i18n: _i18n,
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_20__App___default.a
  }
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return copyright; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return crmUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return theme; });


var customization = {
  crmUrl: "",
  theme: {
    direction: "top-bottom" },

  copyright: "<span>Copyright © 2017 苏州瑞泰信息技术有限公司 All Rights Reserved</span>"
};

var copyright = customization.copyright;
var crmUrl = customization.crmUrl;
var theme = customization.theme;

/* unused harmony default export */ var _unused_webpack_default_export = (customization);

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_locale_lang_zh_CN__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_locale_lang_zh_CN__ = __webpack_require__(295);






var locales = [{
    value: 'zh-CN',
    name: 'Chinese',
    native: '简体中文'
}, {
    value: 'en-US',
    name: 'English',
    native: 'English'
}];

var messages = {
    "zh-CN": __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_CN___default.a, __WEBPACK_IMPORTED_MODULE_2__components_locale_lang_zh_CN__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__module_locale_lang_zh_CN__["a" /* default */])
};

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__progress__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'RtApprovalProgressDialog',
    components: {
        'rt-approval-progress': __WEBPACK_IMPORTED_MODULE_0__progress___default.a
    },
    data: function data() {
        return {
            dialogVisible: false
        };
    },

    props: {
        entityName: {
            type: String,
            require: true
        },
        entityId: {
            type: String,
            require: true
        }
    },
    methods: {
        show: function show() {
            this.dialogVisible = true;
        }
    }

});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RtApprovalProgress',
  data: function data() {
    return {
      stateList: [],
      trackList: []
    };
  },

  props: {
    entityName: {
      type: String,
      require: true
    },
    entityId: {
      type: String,
      require: true
    }
  },
  watch: {
    entityId: function entityId(val) {
      this.getStateList();
      this.getTrackList();
    }
  },
  mounted: function mounted() {
    this.getStateList();
    this.getTrackList();
  },
  methods: {
    getStateList: function getStateList() {
      var _this = this;

      if (rt.isNullOrWhiteSpace(this.entityId)) {
        return;
      }
      rt.get("../api/CrmFlow/GetFlowApproveProgressList?entityName=" + this.entityName + "&entityId=" + this.entityId).then(function (res) {
        if (res == null || res.length == 0) {
          return;
        }
        _this.stateList = res;
      }).catch(function (error) {
        rt.showErrorToast(error);
      });
    },
    getTrackList: function getTrackList() {
      var _this2 = this;

      if (rt.isNullOrWhiteSpace(this.entityId)) {
        return;
      }
      rt.get("../api/CrmFlow/GetFlowApproveLogList?entityName=" + this.entityName + "&entityId=" + this.entityId).then(function (res) {
        _this2.trackList = res;
      }).catch(function (error) {
        rt.showErrorToast(error);
      });
    }
  }
});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RtButton",
  props: {
    type: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    text: {
      type: String
    }
  },
  data: function data() {
    return {
      iconClass: null,
      buttonText: null
    };
  },
  created: function created() {
    this.iconClass = "rt-icon-" + this.type;
    switch (this.type) {
      case "add":
        this.buttonText = this.text || "新建";
        break;
      case "print":
        this.buttonText = this.text || "打印";
        break;
      case "confirm":
        this.buttonText = this.text || "确认";
        break;
      case "approve-progress":
        this.buttonText = this.text || "审批进度";
        break;
      case "delete":
        this.buttonText = this.text || "删除";
        break;
      case "enable":
        this.buttonText = this.text || "启用";
        break;
      case "disable":
        this.buttonText = this.text || "停用";
        break;
      case "more":
        this.buttonText = this.text || "更多";
        break;
      case "export":
        this.buttonText = this.text || "导出";
        break;
      case "import":
        this.buttonText = this.text || "导入";
        break;
      case "submit":
        this.buttonText = this.text || "提交";
        break;
      case "revert":
        this.buttonText = this.text || "撤回";
        break;
      case "download":
        this.buttonText = this.text || "下载";
        break;
      case "save":
        this.buttonText = this.text || "保存";
        break;
      default:
        this.iconClass = "";
        this.buttonText = this.text || "<Text>";
        break;
    }
  },

  methods: {
    handleClick: function handleClick() {
      this.$emit("click");
    }
  }
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "RtContent",
    props: {},
    data: function data() {
        return {
            sideStyle: null
        };
    },
    mounted: function mounted() {
        if (this.$slots.side) {}
    }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "RtExcelImportDialog",
    props: {
        title: {
            type: String,
            require: true
        },
        action: {
            type: String,
            require: true
        },
        templateUrl: String,
        onSuccess: Function
    },
    data: function data() {
        return {
            dialogVisible: false,

            isImporting: false,
            selectedFile: {},
            importResult: null,
            isSuccessed: null
        };
    },

    computed: {
        templateExcelUrl: function templateExcelUrl() {
            return rt.getBaseUrl() + this.templateUrl;
        }
    },
    methods: {
        handleChange: function handleChange(file, fileList) {
            this.selectedFile = file;
        },
        handleImport: function handleImport() {
            this.$refs.upload.submit();
        },
        handleHttpRequest: function handleHttpRequest() {
            var _this = this;

            if (this.isImporting) {
                return;
            }

            this.importResult = null;
            this.isSuccessed = null;

            this.isImporting = true;
            var data = new FormData();
            data.append("file", this.selectedFile.raw);

            rt.post(this.action, data).then(function (res) {
                _this.isSuccessed = true;
                _this.importResult = res;
                _this.isImporting = false;

                if (_this.onSuccess) {
                    _this.onSuccess();
                }
            }, function (error) {
                _this.isSuccessed = false;
                _this.importResult = error;
                _this.isImporting = false;
            });
        },
        handleDialogClose: function handleDialogClose() {
            this._reset();

            this.dialogVisible = false;
        },
        show: function show() {
            this.dialogVisible = true;
        },
        _reset: function _reset() {
            this.$refs.upload.clearFiles();

            this.isImporting = false;
            this.selectedFile = {};
            this.importResult = null;
            this.isSuccessed = null;
        }
    }
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RtExcelImport",
  props: {
    action: {
      type: String,
      require: true
    },
    templateUrl: String,
    onSuccess: Function
  },
  data: function data() {
    return {
      isImporting: false,
      selectedFile: {},
      importResult: null,
      isSuccessed: null
    };
  },
  computed: {
    templateExcelUrl: function templateExcelUrl() {
      return rt.getBaseUrl() + this.templateUrl;
    }
  },
  methods: {
    handleChange: function handleChange(file, fileList) {
      this.selectedFile = file;
    },
    handleImport: function handleImport() {
      this.$refs.upload.submit();
    },
    handleHttpRequest: function handleHttpRequest() {
      var _this = this;

      if (this.isImporting) {
        return;
      }

      this.importResult = null;
      this.isSuccessed = null;

      this.isImporting = true;
      var data = new FormData();
      data.append("file", this.selectedFile.raw);

      rt.post(this.action, data).then(function (res) {
        _this.isSuccessed = true;
        _this.importResult = res;
        _this.isImporting = false;

        if (_this.onSuccess) {
          _this.onSuccess();
        }
      }, function (error) {
        _this.isSuccessed = false;
        _this.importResult = error;
        _this.isImporting = false;
      });
    }
  }
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RtFlowSubmitDialog",
  data: function data() {
    return {
      isSubmiting: false,
      dialogVisible: false,
      selectedFlowId: "",
      flowList: [],
      selectedUserId: [],
      stepList: [],
      canSubmit: false
    };
  },

  props: {
    entityName: {
      type: String,
      require: true
    },
    entityId: {
      type: String,
      require: true
    },
    onSuccess: {
      type: Function
    }
  },
  mounted: function mounted() {},
  watch: {
    selectedFlowId: function selectedFlowId(val) {
      var _this = this;

      if (rt.isNullOrWhiteSpace(val)) {
        this.stepList = [];
        return;
      }
      rt.get("../api/CrmFlow/GetFlowStepList?flowId=" + val + "&entityName=" + this.entityName + "&entityId=" + this.entityId).then(function (res) {
        for (var i in res) {
          if (res[i].new_stepusers != null && res[i].new_stepusers.length > 0) {
            res[i].selectedUserId = res[i].new_stepusers[0].systemuserid;
          }
        }
        _this.stepList = res;
        _this.canSubmit = true;
      }).catch(function (error) {
        _this.canSubmit = false;
        rt.showErrorToast(error);
      });
    }
  },
  methods: {
    getFlowList: function getFlowList() {
      var _this2 = this;

      rt.get("../api/CrmFlow/GetFlowList?entityName=" + this.entityName + "&entityId=" + this.entityId).then(function (res) {
        if (res.length > 0) {
          _this2.flowList = res;
          _this2.selectedFlowId = res[0].new_flowid;
        }
      }).catch(function (error) {
        rt.showErrorToast(error);
      });
    },
    submitFlow: function submitFlow() {
      var _this3 = this;

      if (this.isSubmiting) {
        return;
      }

      var approveList = [];
      this.stepList.map(function (step) {
        approveList.push({
          StepId: step.new_flowstepsid,
          ApproveUserId: step.selectedUserId
        });
      });
      var data = {
        EntityId: this.entityId,
        EntityTypeName: this.entityName,
        FlowId: this.selectedFlowId,
        ApproveList: approveList
      };
      this.isSubmiting = true;
      rt.post("../api/CrmFlow/submit", data).then(function (res) {
        rt.showSuccessToast(res);
        if (_this3.onSuccess) {
          _this3.onSuccess();
        }
        _this3.closeDialog();
        _this3.isSubmiting = false;
      }).catch(function (error) {
        rt.showErrorToast(error);
        _this3.isSubmiting = false;
      });
    },
    handleClose: function handleClose() {
      this.closeDialog();
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
      this.flowList = [];
      this.selectedFlowId = "";
    },
    show: function show() {
      this.dialogVisible = true;
      this.getFlowList();
    }
  }
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RtGrid",
  data: function data() {
    return {
      quickSearch: null,

      showHidden: false,
      moreHeight: 0,
      pageIndex: 1,
      pageSize: 20,
      layout: "total, sizes, prev, pager, next, jumper",
      pageSizes: [10, 20, 30, 40, 50]
    };
  },

  props: {
    quicksearchPlaceholder: String,
    showPagination: {
      type: Boolean,
      default: true,
      required: false
    },
    totalRecord: {
      type: Number,
      required: false
    }
  },
  computed: {
    iconClass: function iconClass() {
      return this.showHidden ? "el-icon-arrow-up" : "el-icon-arrow-down";
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    handleCollapse: function handleCollapse() {
      var _this = this;

      this.showHidden = !this.showHidden;

      this.$nextTick(function () {
        var tableHeight = document.body.clientHeight - 300;
        var moreHeight = document.getElementById("grid__moresearch").clientHeight;

        _this.$store.commit("UPDATE_TABLE_HEIGHT", tableHeight - moreHeight);
      });
    },
    handleReset: function handleReset() {
      this.$emit("reset");
    },
    handleSearch: function handleSearch() {
      this.pageIndex = 1;
      this.$emit("search");
    },
    handleQuickSearch: function handleQuickSearch() {
      this.pageIndex = 1;
      this.$emit("quick-search");
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.$emit("page-change", this.pageIndex, this.pageSize);
    },
    handleIndexChange: function handleIndexChange(val) {
      this.pageIndex = val;
      this.$emit("page-change", this.pageIndex, this.pageSize);
    },
    getPageIndex: function getPageIndex() {
      return this.pageIndex;
    },
    getPageSize: function getPageSize() {
      return this.pageSize;
    },
    getSearchString: function getSearchString() {
      return this.quickSearch;
    },
    setSearchString: function setSearchString(quicksearch) {
      this.quickSearch = quicksearch;
    }
  }
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "RtHeader",
    props: {
        title: {
            type: String,
            default: '',
            required: true
        }
    }
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RtLookupDialog",
  props: {
    entity: {
      type: String,
      required: true
    },
    requestUrl: {
      type: String,
      default: function _default() {
        return "../api/crmlookupview/data";
      }
    },
    nameField: {
      type: String,
      default: function _default() {
        return "new_name";
      }
    },
    idField: {
      type: String,
      default: function _default() {
        return this.entity + "id";
      }
    },
    displayFields: {
      type: Array,
      default: function _default() {
        return [{ name: "new_name", label: "名称" }, { name: "createdon", label: "创建日期", width: 180 }];
      }
    },
    orderbyFields: {
      type: String,
      default: function _default() {
        return "createdon desc";
      }
    },
    customConditions: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    filterFields: {
      type: String,
      default: function _default() {
        return "new_name";
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,

      filterValue: "",

      pageIndex: 1,
      pageSize: 20,
      layout: "total, sizes, prev, pager, next",
      pageSizes: [10, 20, 30, 40, 50],
      totalRecordCount: 0,

      tableData: [],
      currentRow: null
    };
  },

  computed: {
    dialogTitle: function dialogTitle() {
      return "查找";
    },

    selectString: {
      get: function get() {
        var selectFields = [];
        selectFields.push(this.nameField);
        selectFields.push(this.idField);
        for (var i in this.displayFields) {
          var fieldName = this.displayFields[i].name;
          if (selectFields.indexOf(fieldName) >= 0) {
            continue;
          }
          selectFields.push(fieldName);
        }

        return selectFields.join(",");
      }
    },
    orderbyString: {
      get: function get() {
        return this.orderbyFields;
      }
    },
    conditionString: {
      get: function get() {
        return this.customConditions;
      }
    },
    filterString: {
      get: function get() {
        return this.filterFields;
      }
    }
  },
  mounted: function mounted() {},

  methods: {
    show: function show() {
      this.dialogVisible = true;

      this.pageIndex = 1;
      this._fetchRecords();
    },
    handleSearch: function handleSearch() {
      this.pageIndex = 1;
      this._fetchRecords();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentRow = val;
    },
    handleSortChange: function handleSortChange() {
      alert("未实现");
    },
    handleSizeChange: function handleSizeChange(pageSize) {
      this.pageSize = pageSize;

      this._fetchRecords();
    },
    handleIndexChange: function handleIndexChange(pageIndex) {
      this.pageIndex = pageIndex;

      this._fetchRecords();
    },
    handleReset: function handleReset() {
      this.$emit("data-selected", {
        id: null,
        logicalName: this.logicalName,
        name: null
      });

      this.dialogVisible = false;
    },
    handleConfirm: function handleConfirm() {
      var selectedRow = this.$refs.lookupTable.store.states.currentRow;
      if (rt.isNull(selectedRow)) {
        rt.showErrorToast("请选择一条记录");
        return;
      }
      this.$emit("data-selected", {
        id: selectedRow[this.idField],
        name: selectedRow[this.nameField]
      });

      this.dialogVisible = false;
    },
    _fetchRecords: function _fetchRecords() {
      var _this = this;

      this.loading = true;
      var requestStr = this.requestUrl + "?entityName=" + this.entity + "&page=" + this.pageIndex + "&count=" + this.pageSize + "&select=" + this.selectString + "&orderby=" + this.orderbyString + "&condition=" + this.conditionString + "&filter=" + this.filterString + "&filterValue=" + encodeURIComponent(this.filterValue || "");

      rt.get(requestStr).then(function (res) {
        _this.tableData = res.Data;
        _this.totalRecordCount = res.TotalRecordCount;

        _this.$nextTick(function () {
          _this.$refs.lookupTable.doLayout();
        });

        _this.loading = false;
      }).catch(function (error) {
        rt.showErrorToast(error);

        _this.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lookup_dialog__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lookup_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lookup_dialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RtLookup",
  props: {
    value: {
      type: Object,
      required: false
    },
    disabled: Boolean,
    entity: {
      type: String,
      required: true
    },
    nameField: String,
    idField: String,
    dialogRequestUrl: String,
    dialogDisplayFields: Array,
    dialogOrderbyFields: String,
    dialogFilterFields: String,
    dialogCustomConditions: String
  },
  components: {
    "rt-lookup-dialog": __WEBPACK_IMPORTED_MODULE_0__lookup_dialog___default.a
  },
  computed: {},
  data: function data() {
    return {
      lookupValue: {}
    };
  },

  watch: {
    value: function value(newValue) {
      this.lookupValue = newValue || {};
    }
  },
  mounted: function mounted() {
    if (this.value) {
      this.lookupValue = this.value;
    }
  },

  methods: {
    showLookupDialog: function showLookupDialog() {
      if (this.disabled) {
        return;
      }
      this.$refs.lookupDialog.show();
    },
    handleDataSelected: function handleDataSelected(val) {
      this.lookupValue = val;
      this.$emit("input", val);

      this.$emit("change", val);
    }
  }
});

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'RtNavItem',
    props: {
        href: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false
        }
    },
    data: function data() {
        return {
            index: 0
        };
    },

    computed: {
        active: function active() {
            return this.index === this.$parent.activeIndex;
        }
    },
    created: function created() {
        this.index = this.$parent.$children.length - 1;
    },
    mounted: function mounted() {},

    methods: {
        handleItemClick: function handleItemClick() {
            if (this.disabled) {
                return;
            }

            this.$parent.activeIndex = this.index;

            var anchor = document.getElementById(this.href.substring(1));
            var contentMains = document.getElementsByClassName("rt-content__main");
            if (contentMains != null) {
                contentMains[0].scrollTop = anchor.offsetTop - 20;
            }
        }
    }
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'RtNav',

    data: function data() {
        return {
            activeIndex: 0
        };
    },
    mounted: function mounted() {
        var contentMain = document.getElementById("contentMain");

        var subs = [];

        var count = this.$children.length;
        for (var i = 0; i < count; i++) {
            var anchor = document.getElementById(this.$children[i].href.substring(1));
            if (anchor != null) {
                subs.push({
                    min: anchor.offsetTop - 20,
                    max: 9999
                });

                if (i != 0) {
                    subs[i - 1].max = anchor.offsetTop - 20;
                }
            }
        }

        var that = this;
        contentMain.onscroll = function () {
            var scrollTop = this.scrollTop;
            for (var i = 0; i < subs.length; i++) {
                if (scrollTop >= subs[i].min && scrollTop < subs[i].max) {
                    that.activeIndex = i;
                    break;
                }
            }
        };
    },

    methods: {}
});

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "RtPicklist",
    props: {
        value: [String, Number],
        entity: {
            type: String,
            required: true
        },
        attribute: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data: function data() {
        return {
            selectedValue: null,
            options: []
        };
    },

    watch: {
        value: function value(newVal, oldVal) {
            this.selectedValue = newVal;
        }
    },
    methods: {
        bindPicklist: function bindPicklist() {
            var self = this;
            rt.get("../api/crmpicklist/options/" + this.entity + "/" + this.attribute).then(function (res) {
                self.options = res;

                if (self.value) {
                    self.selectedValue = self.value;
                }
            });
        },
        handleChange: function handleChange(val) {
            this.$emit("input", val);

            this.$emit("change", val);
        }
    },
    mounted: function mounted() {
        this.bindPicklist();
    }
});

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "RtQuery",
    props: {
        rows: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            showHidden: true
        };
    },

    computed: {
        icon: function icon() {
            return this.showHidden ? "arrow-down" : "arrow-up";
        },
        hintMessage: function hintMessage() {
            return this.showHidden ? "点击展开" : "点击收起";
        }
    },
    methods: {
        handleCollapse: function handleCollapse() {
            this.showHidden = !this.showHidden;
            this.$emit('collapse', this.showHidden);
        },
        handleReset: function handleReset() {
            this.$emit('reset');
        },
        handleSearch: function handleSearch() {
            this.$emit('search');
        }
    }
});

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "RtSection",
    props: {
        title: {
            type: String,
            default: '',
            required: true
        },
        collapsed: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            isCollapsed: this.collapsed
        };
    },

    computed: {
        iconClass: function iconClass() {
            return this.isCollapsed ? "el-icon-arrow-down" : "el-icon-arrow-right";
        }
    },
    methods: {
        handleClick: function handleClick() {
            this.isCollapsed = !this.isCollapsed;
        }
    }
});

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "RtToolbar",
    props: {
        showBack: {
            type: Boolean,
            default: false,
            required: false
        },
        showAutoback: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    methods: {
        handleBackClick: function handleBackClick() {
            if (this.showAutoback) {
                this.$router.back();
            } else {
                this.$emit("goback");
            }
        }
    }
});

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;

    this.updateTableHeight();

    window.onresize = function () {
      _this.updateTableHeight();
    };
  },
  methods: {
    updateTableHeight: function updateTableHeight() {
      var documentHeight = document.body.clientHeight;
      this.$store.commit("UPDATE_TABLE_HEIGHT", documentHeight - 300);
    }
  }
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);




!function (factory) {
  if ("function" === 'function' && (typeof exports === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(exports)) === 'object' && ( false ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(module)) === 'object') {
    var target = module['exports'] || exports;
    factory(target);
  } else if (typeof define === 'function' && __webpack_require__(616)) {
    define(['exports'], factory);
  } else {
    factory(window['rt'] = {});
  }
}(function (utExports) {
  'use strict';

  var rt = typeof utExports !== 'undefined' ? utExports : {};

  var odataRequestUrl = "../api/crmdata/";

  rt.createAsync = function (entitySetName, entity) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (!rt.isString(entitySetName)) {
        throw new Error('rt.createAsyn entitySetName parameter must be a string.');
      }
      if (rt.isNull(entity)) {
        throw new Error('rt.createAsyn entity parameter must not be null or undefined.');
      }

      rt.post(odataRequestUrl + 'create/' + entitySetName, entity).then(function (res) {
        resolve(res.headers['odata-entityid'].split('(')[1].replace(')', ''));
      }).catch(function (err) {
        reject(err);
      });
    });
  };

  rt.deleteAsync = function (entitySetName, entityId) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (!rt.isString(entitySetName)) {
        throw new Error('rt.deleteAsyn entitySetName parameter must be a string.');
      }
      if (!rt.isString(entityId)) {
        throw new Error('rt.deleteAsyn entityId parameter must be a string.');
      }

      rt.post(odataRequestUrl + 'delete/' + entitySetName + '(' + entityId.replace('{', '').replace('}', '') + ')').then(function (res) {
        resolve(res.status);
      }).catch(function (err) {
        reject(err);
      });
    });
  };

  rt.retrieveAsync = function (queryString, useFormattedValue) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (!rt.isString(queryString)) {
        throw new Error('rt.retrieve queryString parameter must be a string.');
      }
      if (!rt.isBoolean(useFormattedValue)) {
        throw new Error('rt.retrieveMultiple useFormattedValue parameter must be a boolean.');
      }
      var url = odataRequestUrl + 'Retrieve/' + queryString;

      var config = {};
      if (useFormattedValue) {
        config = {
          headers: {
            Prefer: 'odata.include-annotations="OData.Community.Display.V1.FormattedValue"'
          }
        };
      }
      rt.get(url, config).then(function (res) {
        resolve(res.data);
      }).catch(function (err) {
        resolve(err);
      });
    });
  };

  rt.retrieveMultipleAsync = function (queryString, useFormattedValue) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (!rt.isString(queryString)) {
        throw new Error('rt.retrieveMultiple queryString parameter must be a string.');
      }
      if (!rt.isBoolean(useFormattedValue)) {
        throw new Error('rt.retrieveMultiple useFormattedValue parameter must be a boolean.');
      }
      var url = odataRequestUrl + 'Retrieve/' + queryString;

      var config = {};
      if (useFormattedValue) {
        config = {
          headers: {
            Prefer: 'odata.include-annotations="OData.Community.Display.V1.FormattedValue"'
          }
        };
      }

      rt.get(url, config).then(function (res) {
        resolve(res.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  };

  rt.fetchAsync = function (entityName, fetchXml, useFormattedValue) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (!rt.isBoolean(useFormattedValue)) {
        throw new Error('rt.fetchAsync useFormattedValue parameter must be a boolean.');
      }
      if (rt.isNullOrWhiteSpace(entityName)) {
        throw new Error('rt.fetchAsync entityName parameter must be string.');
      }
      if (rt.isNullOrWhiteSpace(fetchXml)) {
        throw new Error('rt.fetchAsync fetchXml parameter must be valuable.');
      }
      var fetchStr = odataRequestUrl + 'Retrieve/' + entityName + '?fetchXml=' + fetchXml;
      if (useFormattedValue) {}
      rt.get(fetchStr).then(function (res) {
        reject(res.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  };

  rt.updateAsync = function (entitySetName, entityId, entity) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (!rt.isString(entitySetName)) {
        throw new Error('rt.updateAsync entitySetName parameter must be a string.');
      }
      if (!rt.isString(entityId)) {
        throw new Error('rt.updateAsync entityId parameter must be a string.');
      }
      if (rt.isNull(entity)) {
        throw new Error('rt.updateAsync entity parameter must not be null or undefined.');
      }

      var url = odataRequestUrl + 'Update/' + entitySetName + '(' + entityId.replace('{', '').replace('}', '') + ')';
      rt.post(url, entity).then(function (res) {
        resolve(res.headers['odata-entityid'].split('(')[1].replace(')', ''));
      }).catch(function (err) {
        resolve(err);
      });
    });
  };

  rt.updateSingleFieldAsync = function (entitySetName, entityId, fieldName, fieldValue) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (!rt.isString(entitySetName)) {
        throw new Error('rt.updateSingleFieldAsync entitySetName parameter must be a string.');
      }
      if (!rt.isString(entityId)) {
        throw new Error('rt.updateSingleFieldAsync entityId parameter must be a string.');
      }

      rt.post(odataRequestUrl + 'Update/' + entitySetName + '(' + entityId.replace('{', '').replace('}', '') + ')/' + fieldName, {
        'value': fieldValue
      }).then(function (res) {
        resolve(res.headers['odata-entityid'].split('(')[1].replace(')', ''));
      }).catch(function (err) {
        reject(err);
      });
    });
  };

  rt.getFieldValueAsync = function (id, typeName, returnField, useFormattedValue) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (!rt.isBoolean(useFormattedValue)) {
        throw new Error('rt.getFieldValueAsync useFormattedValue parameter must be a boolean.');
      }
      if (rt.isNullOrWhiteSpace(id)) {
        throw new Error('rt.getFieldValueAsync id parameter must be string.');
      }
      if (rt.isNullOrWhiteSpace(typeName)) {
        throw new Error('rt.getFieldValueAsync typeName parameter must be string.');
      }

      var queryString = odataRequestUrl + 'Retrieve/' + typeName + '(' + id.replace('{', '').replace('{', '') + ')';
      if (!rt.isNullOrWhiteSpace(returnField) && returnField != "*") {
        queryString += '?$select=' + returnField;
      }

      rt.get(queryString).then(function (res) {
        resolve(res.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  };

  rt.getParameterValue = function (paramName) {
    var result;
    var fetchXml = "<fetch mapping='logical' version='1.0'>" + "<entity name='new_systemparameter'>" + "<attribute name='new_value' />" + "<filter>" + "<condition attribute='new_name' operator='eq' value='" + paramName + "' />" + "</filter>" + "</entity>" + "</fetch>";

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(rt.fetchAsync('new_systemparameters', fetchXml, false).then(function (res) {
      return res.value[0].new_value;
    }));
  };

  rt.export2Excel = function (filename, val, excelTitle, exclude) {
    var excludelist = [];

    if (exclude) {
      excludelist = exclude.split(',');
    }
    var explorer = '';
    if (!!window.ActiveXObject || "ActiveXObject" in window) explorer = 'ie';

    if (explorer == 'ie') {
      var arrData = (typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(val)) != 'object' ? JSON.parse(val) : val;
      try {
        var oXL = new ActiveXObject("Excel.Application");
      } catch (e) {
        alert("无法启动Excel，请确保电脑中已经安装了Excel!\n\n如果已经安装了Excel，" + "请调整IE的安全级别。\n\n具体操作：\n\n" + "工具 → Internet选项 → 安全 → 自定义级别 → ActiveX 控件和插件 → 对未标记为可安全执行脚本的ActiveX 控件初始化并执行脚本 → 启用 → 确定");
      }
      var oWB = oXL.Workbooks.Add();
      var oSheet = oWB.ActiveSheet;
      var Lenr = arrData.length;
      for (var i = 0; i < excelTitle.length; i++) {
        oSheet.Cells(1, i + 1).value = excelTitle[i];
      }

      for (var i = 0; i < Lenr; i++) {
        var td = 0;
        for (var j in arrData[i]) {
          if (excludelist.length > 0 && excludelist.indexOf(j) >= 0) continue;
          oSheet.Cells(i + 2, td + 1).value = arrData[i][j];
          td++;
        }
      }
      oXL.Visible = true;

      var fname = oXL.Application.GetSaveAsFilename(filename + ".xls", "Excel Spreadsheets (*.xls), *.xls");
      oWB.SaveAs(fname);
      oWB.Close();
      oXL.Quit();
    } else {
        var arrData = (typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(val)) != 'object' ? JSON.parse(val) : val;
        var excel = '<table>';
        var row = "<tr>";
        for (var i = 0; i < excelTitle.length; i++) {
          row += "<td>" + excelTitle[i] + "</td>";
        }
        excel += row + "</tr>";
        for (var i = 0; i < arrData.length; i++) {
          var row = "<tr>";
          for (var j in arrData[i]) {
            if (excludelist.length > 0 && excludelist.indexOf(j) >= 0) continue;
            var td = arrData[i][j];
            row += "<td>" + td + "</td>";
          }
          excel += row + "</tr>";
        }
        excel += "</table>";
        var excelFile = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " + "xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";
        excelFile += '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
        excelFile += '<meta http-equiv="content-type" content="application/vnd.ms-excel';
        excelFile += '; charset=UTF-8">';
        excelFile += "<head>";
        excelFile += "<!--[if gte mso 9]>";
        excelFile += "<xml>";
        excelFile += "<x:ExcelWorkbook>";
        excelFile += "<x:ExcelWorksheets>";
        excelFile += "<x:ExcelWorksheet>";
        excelFile += "<x:Name>";
        excelFile += "sheet";
        excelFile += "</x:Name>";
        excelFile += "<x:WorksheetOptions>";
        excelFile += "<x:DisplayGridlines/>";
        excelFile += "</x:WorksheetOptions>";
        excelFile += "</x:ExcelWorksheet>";
        excelFile += "</x:ExcelWorksheets>";
        excelFile += "</x:ExcelWorkbook>";
        excelFile += "</xml>";
        excelFile += "<![endif]-->";
        excelFile += "</head>";
        excelFile += "<body>";
        excelFile += excel;
        excelFile += "</body>";
        excelFile += "</html>";
        var uri = 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(excelFile);
        var link = document.createElement("a");
        link.href = uri;
        link.style = "visibility:hidden";

        link.download = filename + ".xls";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
  };

  rt.revoke = function (entityname, entityid) {
    var data = {
      EntityId: entityid,
      EntityTypeName: entityname
    };
    return rt.post("../api/CrmFlow/revoke", data).then(function (res) {
      rt.showSuccessToast(res);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    }).catch(function (error) {
      rt.showErrorToast(error);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  };

  rt.getBaseUrl = function () {
    if (true) {
      return "";
    }

    var baseUrl = localStorage.serverAddress;
    if (!baseUrl.endWith("/")) {
      baseUrl += "/";
    }

    return baseUrl;
  };

  var ERROR_CONFLICT_MESSAGE = '您的账号在其他地方登录，如果不是你本人操作，请尽快修改登录密码';

  rt.get = function (apiUrl, params) {
    if (!this.isNull(params)) {
      var queryString = null;
      for (var key in params) {
        queryString += "&" + key + "=" + encodeURIComponent(params[key]);
      }
      apiUrl += "?" + queryString.substr(1);
    }

    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(apiUrl).then(function (response) {
      if (response.data != null && response.data.ErrorCode != null) {
        if (response.data.ErrorCode !== 0) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response.data.Message);
        } else {
          return response.data.Data;
        }
      }
      return response.data;
    }, function (errorResponse) {
      if (errorResponse.status == 409 && errorResponse.statusText == 'unauthorized') {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$auth.logout();
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(ERROR_CONFLICT_MESSAGE);
      }

      if (errorResponse.status === 401) {
        alert("您没有权限访问该资源.");
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(errorResponse.statusText);
    });
  };

  rt.post = function (apiUrl, data) {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(apiUrl, data).then(function (response) {
      if (response.data != null && response.data.ErrorCode != null) {
        if (response.data.ErrorCode !== 0) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response.data.Message);
        } else {
          return response.data.Data;
        }
      }
      return response.data;
    }, function (errorResponse) {
      if (errorResponse.status == 409 && errorResponse.statusText == 'unauthorized') {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$auth.logout();
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(ERROR_CONFLICT_MESSAGE);
      }

      if (errorResponse.status === 401) {
        alert("您没有权限访问该资源.");
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(errorResponse.statusText);
    });
  };

  var loadingInstance;

  rt.sLookup = function (url) {
    var l = (screen.availWidth - 560) / 2;
    var t = (screen.availHeight - 614) / 2;

    window.open(url, "_blank", "width=560,height=614,top=" + t + ",left=" + l + ",toolbar=no,menubar=no, scrollbars=no, resizable=no, location=no, status=no");
  };

  rt.editWindow = function (url) {
    var l = (screen.availWidth - 1440) / 2;
    var t = (screen.availHeight - 900) / 2;

    window.open(url, "_blank", "width=1440,height=900,top=" + t + ",left=" + l + ",toolbar=no,menubar=no, scrollbars=no, resizable=no, location=no, status=no");
  };

  rt.alert = function (content, callback) {
    rt.showAlertDialog('提示', content, {
      callback: callback
    });
  };

  rt.showAlertDialog = function (title, content, options) {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$alert(content, title, options);
  };

  rt.confirm = function (content) {
    return rt.showConfirmDialog('', content, '确定', '取消', 'info');
  };

  rt.showConfirmDialog = function (title, content, confirmButtonContent, CancelButtonContent, confirmType) {
    if (!rt.isString(title)) {
      throw new Error('rt.showConfirmDialog title parameter must be string.');
    }
    if (!rt.isString(content)) {
      throw new Error('rt.showConfirmDialog content parameter must be string.');
    }
    if (!rt.isString(confirmButtonContent)) {
      throw new Error('rt.showConfirmDialog confirmButtonContent parameter must be string.');
    }
    if (!rt.isString(CancelButtonContent)) {
      throw new Error('rt.showConfirmDialog CancelButtonContent parameter must be string.');
    }
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$confirm(content, title, {
      confirmButtonText: confirmButtonContent,
      CancelButtonText: CancelButtonContent,
      type: confirmType
    });
  };

  rt.showLoadingToast = function (content, dom) {
    if (!rt.isNull(loadingInstance)) {
      return;
    }
    var options = {};
    if (!rt.isNull(content)) {
      options.text = content;
    }
    if (!rt.isNull(dom)) {
      options.target = dom;
    }
    loadingInstance = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$loading(options);
  };

  rt.hideLoadingToast = function () {
    if (rt.isNull(loadingInstance)) {
      return;
    }
    loadingInstance.close();
    loadingInstance = null;
  };

  rt.showErrorToast = function (content, isClose) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$message({
      showClose: isClose,
      message: content,
      type: 'error'
    });
  };

  rt.showSuccessToast = function (content, isClose) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$message({
      showClose: isClose,
      message: content,
      type: 'success'
    });
  };

  rt.goBack = function () {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].router.go(-1);
  };

  rt.logout = function () {
    rt.showConfirmDialog('', '确认注销？', '确定', '取消', 'warning').then(function () {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$auth.logout();
    });
  };

  rt.getUserId = function () {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].store.state.user.userId;
  };

  rt.getUserName = function () {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].store.state.user.userName;
  };

  rt.getDepartId = function () {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].store.state.user.departId;
  };

  rt.getPaginationSize = function () {
    return 50;
  };

  rt.refreshParentPage = function () {
    if (window.top != null && window.top.opener != null) {
      window.top.opener.location.reload();
    }
  };

  rt.showFullWindow = function (url) {
    var width = screen.width;
    var height = screen.height;
    return this.showWindow(url, {
      width: width,
      height: height
    });
  };

  rt.showLargeWindow = function (url) {
    return this.showWindow(url, {
      width: 1024,
      height: 768
    });
  };

  rt.showSmallWindow = function (url) {
    return this.showWindow(url, {
      width: 400,
      height: 300
    });
  };

  rt.showWindow = function (url, config) {
    if (this.isNull(config)) {
      config = {};
    }

    if (this.isNull(config.width) || config.width === 0) {
      config.width = 800;
    }

    if (this.isNull(config.height) || config.height === 0) {
      config.height = 600;
    }

    var WINDOWS_TASK_BAR_HEIGHT = 40;
    var winTop = Math.round((screen.height - config.height - WINDOWS_TASK_BAR_HEIGHT) * 0.5);
    var winLeft = Math.round((screen.width - config.width) * 0.5);

    var strFeatures = "help=no,maximize=no,minimize=no,menubar=no,toolbar=no,status=no,location=no,resizable=no" + ",width=" + config.width + ",height=" + config.height + ",top=" + winTop + ",left=" + winLeft;

    window.open(url, "_blank", strFeatures);
  };

  rt.refresh = function () {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].router.go(0);
  };

  Date.prototype.dateAdd = function (datepart, number) {
    var d = new Date(this.getTime());

    var k = {
      'y': 'FullYear',
      'q': 'Month',
      'm': 'Month',
      'w': 'Date',
      'd': 'Date',
      'h': 'Hours',
      'n': 'Minutes',
      's': 'Seconds',
      'ms': 'MilliSeconds'
    };
    var n = {
      'q': 3,
      'w': 7
    };
    eval('d.set' + k[datepart] + '(d.get' + k[datepart] + '()+' + (n[datepart] || 1) * number + ')');
    return d;
  };

  Date.prototype.dateDiff = function (datepart, enddate) {
    var d = this,
        i = {},
        t = d.getTime(),
        t2 = enddate.getTime();
    i['y'] = enddate.getFullYear() - d.getFullYear();
    i['q'] = i['y'] * 4 + Math.floor(enddate.getMonth() / 4) - Math.floor(d.getMonth() / 4);
    i['m'] = i['y'] * 12 + enddate.getMonth() - d.getMonth();
    i['ms'] = enddate.getTime() - d.getTime();
    i['w'] = Math.floor((t2 + 345600000) / 604800000) - Math.floor((t + 345600000) / 604800000);
    i['d'] = Math.floor(t2 / 86400000) - Math.floor(t / 86400000);
    i['h'] = Math.floor(t2 / 3600000) - Math.floor(t / 3600000);
    i['n'] = Math.floor(t2 / 60000) - Math.floor(t / 60000);
    i['s'] = Math.floor(t2 / 1000) - Math.floor(t / 1000);
    return i[datepart];
  };

  Date.prototype.toUniversalTime = function () {
    var yearUTC = this.getUTCFullYear();
    var monthUTC = this.getUTCMonth();
    var dayUTC = this.getUTCDate();
    var hoursUTC = this.getUTCHours();
    var minutesUTC = this.getUTCMinutes();
    var secondsUTC = this.getUTCSeconds();

    return new Date(yearUTC, monthUTC, dayUTC, hoursUTC, minutesUTC, secondsUTC);
  };

  String.prototype.contains = function (substr, ignoreCase) {
    if (ignoreCase === null || ignoreCase === undefined) {
      ignoreCase = false;
    }

    if (ignoreCase) {
      return this.search(new RegExp(substr, "i")) > -1;
    } else {
      return this.search(substr) > -1;
    }
  };

  String.prototype.endWith = function (s, ignoreCase) {
    if (s === null || s === "" || this.length === 0 || s.length > this.length) {
      return false;
    }
    var ns = this.substring(this.length - s.length);
    if (ignoreCase) {
      return ns.toLowerCase() === s.toLowerCase();
    } else {
      return ns === s;
    }
  };

  String.prototype.format = function () {
    var content = this;
    for (var i = 0; i < arguments.length; i++) {
      var replacement = '{' + i + '}';
      content = content.replace(replacement, arguments[i]);
    }
    return content;
  };

  String.prototype.startWith = function (s, ignoreCase) {
    if (s === null || s === "" || this.length === 0 || s.length > this.length) {
      return false;
    }
    var ns = this.substr(0, s.length);
    if (ignoreCase) {
      return ns.toLowerCase() === s.toLowerCase();
    } else {
      return ns === s;
    }
  };

  String.prototype.trim = function (trimChars) {
    var result = this;

    if (typeof trimChars !== "string" || trimChars.length <= 0) {
      trimChars = " ";
    }

    var count = result.length;

    while (count > 0) {
      if (trimChars.indexOf(result[0]) >= 0) {
        result = result.substring(1);
        count--;
      } else {
        break;
      }
    }
    while (count > 0) {
      if (trimChars.indexOf(result[count - 1]) >= 0) {
        result = result.substring(0, count - 1);
        count--;
      } else {
        break;
      }
    }
    return result;
  };

  rt.convertGPS2BaiduLocation = function (longitude, latitude, success) {
    var url = "http://api.map.baidu.com/geoconv/v1/?coords=" + longitude + "," + latitude + "&from=1&to=5&ak=ROninBdEIu93CBGDHc3fSPHE&callback=MYCALLBACK";

    this.jsonp(url, function (data) {
      success(data.result[0]);
    });
  };

  rt.delay = function (action, delayMilliseconds) {
    if (!this.isFunction(action)) {
      throw new Error("第一个参数必须是function对象.");
    }

    if (this.isNull(delayMilliseconds)) {
      delayMilliseconds = 2 * 1000;
    }

    setTimeout(action, delayMilliseconds);
  };

  rt.formatDateTime = function (date, mask, utc) {

    var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
        timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
        timezoneClip = /[^-+\dA-Z]/g,
        pad = function pad(val, len) {
      val = String(val);
      len = len || 2;
      while (val.length < len) {
        val = "0" + val;
      }return val;
    };

    var dateFormat = {
      masks: {},
      i18n: {}
    };

    dateFormat.masks = {
      "default": "ddd mmm dd yyyy HH:MM:ss",
      shortDate: "m/d/yy",
      mediumDate: "mmm d, yyyy",
      longDate: "mmmm d, yyyy",
      fullDate: "dddd, mmmm d, yyyy",
      shortTime: "h:MM TT",
      mediumTime: "h:MM:ss TT",
      longTime: "h:MM:ss TT Z",
      isoDate: "yyyy-mm-dd",
      isoTime: "HH:MM:ss",
      isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
      isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
    };

    dateFormat.i18n = {
      dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    };

    return function (date, mask, utc) {
      var dF = dateFormat;

      if (arguments.length === 1 && Object.prototype.toString.call(date) === "[object String]" && !/\d/.test(date)) {
        mask = date;
        date = undefined;
      }

      date = date ? new Date(date) : new Date();
      if (isNaN(date)) throw SyntaxError("invalid date");

      mask = String(dF.masks[mask] || mask || dF.masks["default"]);

      if (mask.slice(0, 4) == "UTC:") {
        mask = mask.slice(4);
        utc = true;
      }

      var _ = utc ? "getUTC" : "get",
          d = date[_ + "Date"](),
          D = date[_ + "Day"](),
          m = date[_ + "Month"](),
          y = date[_ + "FullYear"](),
          H = date[_ + "Hours"](),
          M = date[_ + "Minutes"](),
          s = date[_ + "Seconds"](),
          L = date[_ + "Milliseconds"](),
          o = utc ? 0 : date.getTimezoneOffset(),
          flags = {
        d: d,
        dd: pad(d),
        ddd: dF.i18n.dayNames[D],
        dddd: dF.i18n.dayNames[D + 7],
        m: m + 1,
        mm: pad(m + 1),
        mmm: dF.i18n.monthNames[m],
        mmmm: dF.i18n.monthNames[m + 12],
        yy: String(y).slice(2),
        yyyy: y,
        h: H % 12 || 12,
        hh: pad(H % 12 || 12),
        H: H,
        HH: pad(H),
        M: M,
        MM: pad(M),
        s: s,
        ss: pad(s),
        l: pad(L, 3),
        L: pad(L > 99 ? Math.round(L / 10) : L),
        t: H < 12 ? "a" : "p",
        tt: H < 12 ? "am" : "pm",
        T: H < 12 ? "A" : "P",
        TT: H < 12 ? "AM" : "PM",
        Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
        o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
        S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
      };

      return mask.replace(token, function ($0) {
        return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
      });
    };
  }();

  rt.formatNumber = function (number, pattern) {

    var str = number.toString();
    var strInt;
    var strFloat;
    var formatInt;
    var formatFloat;
    if (/\./g.test(pattern)) {
      formatInt = pattern.split('.')[0];
      formatFloat = pattern.split('.')[1];
    } else {
      formatInt = pattern;
      formatFloat = null;
    }

    if (/\./g.test(str)) {
      if (formatFloat !== null) {
        var tempFloat = Math.round(parseFloat('0.' + str.split('.')[1]) * Math.pow(10, formatFloat.length)) / Math.pow(10, formatFloat.length);
        strInt = (Math.floor(number) + Math.floor(tempFloat)).toString();
        strFloat = /\./g.test(tempFloat.toString()) ? tempFloat.toString().split('.')[1] : '0';
      } else {
        strInt = Math.round(number).toString();
        strFloat = '0';
      }
    } else {
      strInt = str;
      strFloat = '0';
    }
    var zero;
    if (formatInt !== null) {
      var outputInt;
      outputInt = '';
      zero = formatInt.match(/0*$/)[0].length;
      var comma = null;
      if (/,/g.test(formatInt)) {
        comma = formatInt.match(/,[^,]*/)[0].length - 1;
      }
      var newReg = new RegExp('(\\d{' + comma + '})', 'g');

      if (strInt.length < zero) {
        outputInt = new Array(zero + 1).join('0') + strInt;
        outputInt = outputInt.substr(outputInt.length - zero, zero);
      } else {
        outputInt = strInt;
      }
      outputInt = outputInt.substr(0, outputInt.length % comma) + outputInt.substring(outputInt.length % comma).replace(newReg, (comma !== null ? ',' : '') + ' JavaScript Content ');
      outputInt = outputInt.replace(/^,/, '');

      strInt = outputInt;
    }

    if (formatFloat !== null) {
      var outputFloat = '';
      zero = formatFloat.match(/^0*/)[0].length;
      if (strFloat.length < zero) {
        outputFloat = strFloat + new Array(zero + 1).join('0');

        var outputFloat1 = outputFloat.substring(0, zero);
        var outputFloat2 = outputFloat.substring(zero, formatFloat.length);
        outputFloat = outputFloat1 + outputFloat2.replace(/0*$/, '');
      } else {
        outputFloat = strFloat.substring(0, formatFloat.length);
      }

      strFloat = outputFloat;
    } else {
      if (pattern !== '' || pattern === '' && strFloat === '0') {
        strFloat = '';
      }
    }

    return strInt + (strFloat === '' ? '' : '.' + strFloat);
  };

  rt.formatDecimal = function (s, n) {
    if (this.isNull(s)) {
      return null;
    }

    n = n > 0 && n <= 20 ? n : 2;
    s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + '';
    var l = s.split('.')[0].split('').reverse(),
        r = s.split('.')[1];
    var t = '';
    for (var i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? ',' : '');
    }
    return t.split('').reverse().join('') + '.' + r;
  };

  rt.getJSON = function (serverUrl) {
    var xmlhttp = this.getXHR();
    xmlhttp.open("get", serverUrl, false);
    xmlhttp.setRequestHeader("Accept", "application/json");
    xmlhttp.setRequestHeader("Content-Type", "application/json; charset=utf-8");
    xmlhttp.send();
    return xmlhttp.responseText;
  };

  rt.getLastDayOfMonth = function () {

    var Nowdate = new Date();
    var MonthNextFirstDay = new Date(Nowdate.getFullYear(), Nowdate.getMonth() + 1, 1);
    return new Date(MonthNextFirstDay - 86400000);
  };

  rt.getObject = function (serverUrl) {
    var json = this.getJSON(serverUrl);
    try {
      return JSON.parse(json);
    } catch (e) {
      return null;
    }
  };

  rt.getResponse = function (serverUrl) {
    var xmlhttp = rt.getXHR();
    xmlhttp.open("get", serverUrl, false);
    xmlhttp.send();

    return xmlhttp.responseText;
  };

  rt.getScreenHeight = function () {
    return document.documentElement.clientHeight || document.body.clientHeight;
  };

  rt.getScreenWidth = function () {
    return document.documentElement.clientWidth || document.body.clientWidth;
  };

  rt.getUrlParam = function (name) {

    try {
      var query = location.search.substring(1);
      var pairs = query.split("&");
      for (var i = 0; i < pairs.length; i++) {
        var pos = pairs[i].indexOf('=');
        if (pos == -1) continue;
        var argname = pairs[i].substring(0, pos);
        if (argname == name) return pairs[i].substring(pos + 1);
      }
    } catch (e) {
      alert(e);
    }
    return '';
  };

  rt.getXHR = function () {
    if (window.XMLHttpRequest) {
      return new XMLHttpRequest();
    } else if (window.ActiveXObject) {
      try {
        return new ActiveXObject("Microsoft.XMLHTTP");
      } catch (e) {
        return new ActiveXObject("Msxml2.XMLHTTP");
      }
    }
    return null;
  };

  rt.isBoolean = function (obj) {
    return typeof obj === "boolean";
  };

  rt.isCellphone = function (str) {
    var regex = /^0*(13|15|18)\d{9}$/;
    return regex.test(str);
  };

  rt.isDate = function (d) {
    if (rt.isNull(d)) {
      return false;
    }

    return d instanceof Date && !isNaN(d.valueOf());
  };

  rt.isEmailAddress = function (str) {
    var regex = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;

    return regex.test(str);
  };

  rt.isFunction = function (f) {
    if (rt.isNull(f)) {
      return false;
    }

    return typeof f === 'function';
  };

  rt.isIDCard = function (str) {
    var regex = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/;
    return regex.test(str);
  };

  rt.isInteger = function (str) {
    var regex = /^[-]{0,1}[0-9]{1,}$/;
    return regex.test(str);
  };

  rt.isNull = function (o) {
    return o === undefined || o === null;
  };

  rt.isNullOrWhiteSpace = function (s) {
    return this.isNull(s) || s.trim() === "";
  };

  rt.isNumeric = function (str) {

    var regex = /^(-|\+)?\d+(\.\d+)?$/;

    return regex.test(str);
  };

  rt.isPhone = function (str) {
    return this.isCellphone(str) || this.isTelephone(str);
  };

  rt.isSameGuid = function (guid1, guid2) {

    var isEqual;
    if (guid1 === null || guid2 === null) {
      isEqual = false;
    } else {
      isEqual = guid1.replace(/[{}]/g, "").toLowerCase() === guid2.replace(/[{}]/g, "").toLowerCase();
    }

    return isEqual;
  };

  rt.isString = function (obj) {
    return typeof obj === "string";
  };

  rt.isTelephone = function (str) {
    var reg = /^\d{3,4}-\d{7,8}(-\d{3,4})?$/;
    return reg.test(str);
  };

  rt.isUnsignedInteger = function (str) {
    var regex = /^[1]{0,1}[0-9]{1,}$/;

    return regex.test(str);
  };

  rt.isUnsignedNumeric = function (str) {
    var regex = /^\d+(\.\d+)?$/;

    return regex.test(str);
  };

  rt.isUrl = function (str) {
    return !this.isNullOrWhiteSpace(str) && (str.startWith("http://") || str.startWith("https://"));
  };

  rt.jsonp = function (url, callback) {
    var callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
    window[callbackName] = function (data) {
      delete window[callbackName];
      document.body.removeChild(script);
      callback(data);
    };

    var script = document.createElement('script');
    script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName;
    document.body.appendChild(script);
  };

  rt.newGuid = function () {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  };

  rt.noop = function () {};

  rt.postResponse = function (url, data) {
    var xmlhttp = this.getXHR();
    xmlhttp.open("post", url, false);
    xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xmlhttp.send(data);

    return xmlhttp.responseText;
  };

  var hexcase = 0;

  var b64pad = "";

  var chrsz = 8;

  rt.md5 = function (s) {
    return hex_md5(s);
  };

  rt.hmacmd5 = function (s) {
    return hex_hmac_md5();
  };

  function hex_md5(s) {
    return binl2hex(core_md5(str2binl(s), s.length * chrsz));
  };

  function b64_md5(s) {
    return binl2b64(core_md5(str2binl(s), s.length * chrsz));
  }

  function str_md5(s) {
    return binl2str(core_md5(str2binl(s), s.length * chrsz));
  }

  function hex_hmac_md5(key, data) {
    return binl2hex(core_hmac_md5(key, data));
  }

  function b64_hmac_md5(key, data) {
    return binl2b64(core_hmac_md5(key, data));
  }

  function str_hmac_md5(key, data) {
    return binl2str(core_hmac_md5(key, data));
  }

  function md5_vm_test() {
    return hex_md5("abc") == "900150983cd24fb0d6963f7d28e17f72";
  }

  function core_md5(x, len) {
    x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;

    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;

    for (var i = 0; i < x.length; i += 16) {
      var olda = a;
      var oldb = b;
      var oldc = c;
      var oldd = d;

      a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
      d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
      c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
      b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
      a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
      d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
      c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
      b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
      a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
      d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
      c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
      b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
      a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
      d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
      c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
      b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

      a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
      d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
      c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
      b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
      a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
      d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
      c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
      b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
      a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
      d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
      c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
      b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
      a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
      d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
      c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
      b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

      a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
      d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
      c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
      b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
      a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
      d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
      c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
      b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
      a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
      d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
      c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
      b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
      a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
      d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
      c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
      b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

      a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
      d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
      c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
      b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
      a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
      d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
      c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
      b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
      a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
      d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
      c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
      b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
      a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
      d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
      c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
      b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

      a = safe_add(a, olda);
      b = safe_add(b, oldb);
      c = safe_add(c, oldc);
      d = safe_add(d, oldd);
    }
    return Array(a, b, c, d);
  }

  function md5_cmn(q, a, b, x, s, t) {
    return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
  }

  function md5_ff(a, b, c, d, x, s, t) {
    return md5_cmn(b & c | ~b & d, a, b, x, s, t);
  }

  function md5_gg(a, b, c, d, x, s, t) {
    return md5_cmn(b & d | c & ~d, a, b, x, s, t);
  }

  function md5_hh(a, b, c, d, x, s, t) {
    return md5_cmn(b ^ c ^ d, a, b, x, s, t);
  }

  function md5_ii(a, b, c, d, x, s, t) {
    return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
  }

  function core_hmac_md5(key, data) {
    var bkey = str2binl(key);
    if (bkey.length > 16) bkey = core_md5(bkey, key.length * chrsz);

    var ipad = Array(16),
        opad = Array(16);
    for (var i = 0; i < 16; i++) {
      ipad[i] = bkey[i] ^ 0x36363636;
      opad[i] = bkey[i] ^ 0x5C5C5C5C;
    }

    var hash = core_md5(ipad.concat(str2binl(data)), 512 + data.length * chrsz);
    return core_md5(opad.concat(hash), 512 + 128);
  }

  function safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
  }

  function bit_rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
  }

  function str2binl(str) {
    var bin = Array();
    var mask = (1 << chrsz) - 1;
    for (var i = 0; i < str.length * chrsz; i += chrsz) {
      bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << i % 32;
    }return bin;
  }

  function binl2str(bin) {
    var str = "";
    var mask = (1 << chrsz) - 1;
    for (var i = 0; i < bin.length * 32; i += chrsz) {
      str += String.fromCharCode(bin[i >> 5] >>> i % 32 & mask);
    }return str;
  }

  function binl2hex(binarray) {
    var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
    var str = "";
    for (var i = 0; i < binarray.length * 4; i++) {
      str += hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 + 4 & 0xF) + hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 & 0xF);
    }
    return str;
  }

  function binl2b64(binarray) {
    var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var str = "";
    for (var i = 0; i < binarray.length * 4; i += 3) {
      var triplet = (binarray[i >> 2] >> 8 * (i % 4) & 0xFF) << 16 | (binarray[i + 1 >> 2] >> 8 * ((i + 1) % 4) & 0xFF) << 8 | binarray[i + 2 >> 2] >> 8 * ((i + 2) % 4) & 0xFF;
      for (var j = 0; j < 4; j++) {
        if (i * 8 + j * 6 > binarray.length * 32) str += b64pad;else str += tab.charAt(triplet >> 6 * (3 - j) & 0x3F);
      }
    }
    return str;
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(617)(module)))

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  LOGIN: "登录",
  LOGIN_USERNAME: "用户名",
  LOGIN_PASSWORD: "密码",
  LOGIN_CAPTCHA: "验证码",
  LOGIN_FORGOT_PASSWORD: "忘记密码?",
  LOGIN_LOGINING: "登录中",
  LOGIN_PLS_INPUT_USERNAME: "请输入用户名",
  LOGIN_PLS_INPUT_PASSWORD: "请输入密码",
  LOGIN_USERNAME_OR_PASSWORD_INCORRECT: "用户名或密码不正确",
  LOGIN_INCORRECT_USERROLE: "当前用户不允许登录Portal",

  SETTING_CHANGE_PASSWORD: "更改密码",
  SETTING_CHANGE_AVATAR: "更换头像",
  SETTING_LOGOUT: "注销",

  BUTTON_ADD: "新增",
  BUTTON_EDIT: "编辑",
  BUTTON_DELETE: "删除",
  BUTTON_EXPORT: "导出",
  BUTTON_IMPORT: "导入",
  BUTTON_SEARCH: "查询"
});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    partapplyname: '配件申请单号',
    servicename: '服务单号',
    applytype: '申请类型',
    approvalstatus: '审批状态',

    startDate: '开始日期',
    endDate: '结束日期',
    noticeType: '公告类型',
    noticeTitle: '公告标题',
    noticeState: '阅读状态'
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Main = function Main(resolve) {
  return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(233)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var App = function App(resolve) {
  return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(148)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var PartApplyList = function PartApplyList(resolve) {
  return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(634)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var PartApplyEdit = function PartApplyEdit(resolve) {
  return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(633)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var PartApplyDetail = function PartApplyDetail(resolve) {
  return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(632)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var NoticeList = function NoticeList(resolve) {
  return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(630)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NoticeView = function NoticeView(resolve) {
  return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(631)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/partsApply',
  component: Main,
  children: [{
    path: 'list',
    name: 'partsApply-list',
    component: PartApplyList,
    meta: {
      keepAlive: true
    }
  }, {
    path: 'create/',
    name: 'partsApply-create',
    component: PartApplyEdit
  }, {
    path: 'edit/:id',
    name: 'partsApply-edit',
    component: PartApplyEdit
  }, {
    path: 'detailcreate/:partid',
    name: 'partsApply-detailcreate',
    component: PartApplyDetail
  }, {
    path: 'detailedit/:id',
    name: 'partsApply-detailedit',
    meta: {
      keepAlive: true
    },
    component: PartApplyDetail
  }]
}, {
  path: "/notice",
  component: Main,
  children: [{
    path: "list",
    name: "NoticeList",
    component: NoticeList
  }, {
    path: "view/:id",
    name: "NoticeView",
    component: NoticeView
  }]
}, {
  path: '/crmpartsApply',
  component: App,
  children: [{
    path: 'list',
    name: 'crm__partsApply-list',
    component: PartApplyList
  }]
}, {
  path: '/crmnotice',
  component: App,
  children: [{
    path: 'list',
    name: 'crm__noticeList',
    component: NoticeList
  }]
}]);

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(98);



var HEARTBEAT_INTERVAL = 60;

/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {
        if (!this._isAlive()) {
            __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].clearAllData();
        }
        localStorage.heartbeat = new Date();

        this._keepAlive();
    },
    _keepAlive: function _keepAlive() {
        setInterval(function () {
            localStorage.heartbeat = new Date();
        }, HEARTBEAT_INTERVAL * 1000);
    },
    _isAlive: function _isAlive() {
        var lastHeartbeat = localStorage.heartbeat;

        if (lastHeartbeat === null || new Date(lastHeartbeat).dateDiff('s', new Date()) > HEARTBEAT_INTERVAL + 30) {
            return false;
        }
        return true;
    }
});

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$http = Vue.http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a;

    if (false) {
      axios.defaults.baseURL = localStorage.serverAddress;
    }
  }
});

/***/ }),

/***/ 299:
/***/ (function(module, exports) {



/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auth", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user", function() { return user; });
var auth = function auth(state) {
  return state.auth;
};
var user = function user(state) {
  return state.user;
};

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_AUTH", function() { return UPDATE_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_USER", function() { return UPDATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_USER_AVATAR", function() { return UPDATE_USER_AVATAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ALL_DATA", function() { return CLEAR_ALL_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_TABLE_HEIGHT", function() { return UPDATE_TABLE_HEIGHT; });
var UPDATE_AUTH = function UPDATE_AUTH(state, auth) {
    state.auth = auth;
};

var UPDATE_USER = function UPDATE_USER(state, user) {
    state.user = user;
};

var UPDATE_USER_AVATAR = function UPDATE_USER_AVATAR(state, avatarUrl) {
    state.user.avatarUrl = avatarUrl;
};

var CLEAR_ALL_DATA = function CLEAR_ALL_DATA(state) {
    state.auth.isLoggedIn = false;
    state.auth.accessToken = null;
    state.auth.refreshToken = null;

    state.user.userId = '';
    state.user.userName = '';
    state.user.nickName = '';
    state.user.loginType = '';
    state.user.departName = '';
    state.user.departId = '';
    state.user.avatarUrl = '';
};

var UPDATE_TABLE_HEIGHT = function UPDATE_TABLE_HEIGHT(state, tableHeight) {
    state.tableHeight = tableHeight;
};

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(161);



var localStoragePlugin = function localStoragePlugin(store) {
    store.subscribe(function (mutation, state) {
        var syncedData = { auth: state.auth, user: state.user };

        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__state__["b" /* STORAGE_KEY */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(syncedData));

        if (mutation.type === 'CLEAR_ALL_DATA') {
            localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1__state__["b" /* STORAGE_KEY */]);
        }
    });
};

/* harmony default export */ __webpack_exports__["a"] = ([localStoragePlugin]);

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(595),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(594),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(609),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(602),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(596),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(567)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(608),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(604),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(607),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(610),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(606),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(597),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(601),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(603),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(600),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(605),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 594:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "type": "text",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    class: _vm.iconClass
  }), _vm._v("\n    " + _vm._s(_vm.buttonText) + "\n")])
},staticRenderFns: []}

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "size": "small",
      "title": "审批进度",
      "close-on-click-modal": false,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.dialogVisible) ? _c('rt-approval-progress', {
    attrs: {
      "entity-name": _vm.entityName,
      "entity-id": _vm.entityId
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "400px",
      "height": "500px"
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Excel数据导入")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "rt-excel-import"
  }, [_c('div', {
    staticClass: "rt-excel-import_tip"
  }, [_vm._v("\r\n                    只能上传Excel(xls或xlsx)文件，且记录数不超过5000条\r\n                ")]), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    attrs: {
      "drag": "",
      "action": "/",
      "accept": ".xls,.xlsx",
      "http-request": _vm.handleHttpRequest,
      "show-file-list": false,
      "on-change": _vm.handleChange,
      "multiple": false,
      "auto-upload": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或\r\n                    "), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("已选择文件：" + _vm._s(_vm.selectedFile.name))])]), _vm._v(" "), _c('div', {
    staticClass: "rt-excel-import__result",
    class: {
      'rt-excel-import__result_error': !_vm.isSuccessed, 'rt-excel-import__result_success': _vm.isSuccessed
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.importResult))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px",
      "line-height": "40px"
    }
  }, [(_vm.templateUrl) ? _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.templateExcelUrl
    }
  }, [_vm._v("下载模板")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isImporting
    },
    on: {
      "click": _vm.handleImport
    }
  }, [_vm._v("导 入")])], 1)])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "rt-nav"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0 15px 45px"
    }
  }, [_c('div', {
    attrs: {
      "id": "approveState"
    }
  }, [(!_vm.stateList || _vm.stateList.length == 0) ? [_c('div', {
    staticClass: "empty-state"
  }, [_vm._v("暂无审批信息")])] : [_c('div', {
    style: ({
      width: (_vm.stateList.length * 200) + 'px'
    })
  }, _vm._l((_vm.stateList), function(state, index) {
    return _c('div', {
      key: state.new_flowapproval_stepsId
    }, [_c('div', {
      staticClass: "node"
    }, [_c('i', {
      staticClass: "node-icon",
      class: {
        'icon-approving': state.new_status === 1, 'icon-approved': state.new_status === 2, 'icon-submit': state.new_status === 0
      }
    }), _vm._v(" "), _c('ul', [_c('li', {
      staticClass: "owner"
    }, [_vm._v(_vm._s(state.new_userName))]), _vm._v(" "), _c('li', {
      staticClass: "date"
    }, [_vm._v(_vm._s(state.new_date))])])]), _vm._v(" "), (index !== _vm.stateList.length - 1) ? _c('div', {
      staticClass: "proce"
    }, [_c('span', [_vm._v("- - - - - - - - - - -")])]) : _vm._e()])
  }))]], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "approveTrack"
    }
  }, [_c('h3', [_vm._v("历史记录")]), _vm._v(" "), _c('ul', _vm._l((_vm.trackList), function(track, index) {
    return _c('li', {
      key: track.new_flowapproval_logId,
      class: {
        last: index === _vm.trackList.length - 1
      }
    }, [_c('div', {
      staticStyle: {
        "margin-top": "0"
      }
    }, [_c('i', {
      staticClass: "node-icon",
      class: {
        first: index === 0
      }
    }), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(track.new_date))]), _vm._v(" "), _c('span', {
      staticClass: "action"
    }, [_vm._v("[" + _vm._s(track.new_actionName) + "]")]), _vm._v(" "), _c('span', {
      staticClass: "step"
    }, [_vm._v(_vm._s(track.new_stepName))]), _vm._v(" "), _c('span', {
      staticClass: "owner"
    }, [_vm._v(_vm._s(track.new_userName))])]), _vm._v(" "), _c('div', {
      staticClass: "memo"
    }, [_c('span', [_vm._v(_vm._s(track.new_memo))])])])])
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "rt-lookup-dialog",
    attrs: {
      "width": "33.3%",
      "close-on-click-modal": false,
      "title": "查找",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "搜索记录"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch($event)
      }
    },
    model: {
      value: (_vm.filterValue),
      callback: function($$v) {
        _vm.filterValue = $$v
      },
      expression: "filterValue"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "-12px"
    },
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.handleSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "lookupTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": "450",
      "highlight-current-row": "",
      "data": _vm.tableData,
      "border": "",
      "stripe": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "row-dblclick": _vm.handleConfirm,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "55"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row == _vm.currentRow) ? _c('i', {
          staticClass: "el-icon-check"
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.displayFields), function(display) {
    return _c('el-table-column', {
      key: display.name,
      attrs: {
        "show-overflow-tooltip": true,
        "prop": display.name,
        "label": display.label,
        "width": display.width
      }
    })
  })], 2), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.pageIndex,
      "page-size": _vm.pageSize,
      "page-sizes": _vm.pageSizes,
      "layout": _vm.layout,
      "total": _vm.totalRecordCount
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleIndexChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("移除值")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-section",
    class: {
      'is-collapsed': _vm.isCollapsed
    }
  }, [_c('div', {
    staticClass: "rt-section__header"
  }, [_c('span', {
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "rt-section__header__arrow el-icon-arrow-down"
  }), _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), (!_vm.isCollapsed) ? _c('rt-toolbar', [_vm._t("toolbar")], 2) : _vm._e()], 1), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCollapsed),
      expression: "!isCollapsed"
    }],
    staticClass: "rt-section__content"
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 601:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "clearable": "",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.Value,
      attrs: {
        "label": item.Text,
        "value": item.Value
      }
    }, [_vm._v("\n        " + _vm._s(item.Text) + "\n    ")])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "size": "auto",
      "title": _vm.title,
      "close-on-click-modal": false,
      "before-close": _vm.handleDialogClose,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "rt-excel-import"
  }, [_c('div', {
    staticClass: "rt-excel-import_tip"
  }, [_vm._v("\n            只能上传Excel(xls或xlsx)文件，且记录数不超过5000条\n        ")]), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    attrs: {
      "drag": "",
      "action": "/",
      "accept": ".xls,.xlsx",
      "http-request": _vm.handleHttpRequest,
      "show-file-list": false,
      "on-change": _vm.handleChange,
      "multiple": false,
      "auto-upload": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或\n                "), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("已选择文件：" + _vm._s(_vm.selectedFile.name))])]), _vm._v(" "), _c('div', {
    staticClass: "rt-excel-import__result",
    class: {
      'rt-excel-import__result_error': !_vm.isSuccessed, 'rt-excel-import__result_success': _vm.isSuccessed
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.importResult))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px",
      "line-height": "40px"
    }
  }, [(_vm.templateUrl) ? _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.templateExcelUrl
    }
  }, [_vm._v("下载模板")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isImporting
    },
    on: {
      "click": _vm.handleImport
    }
  }, [_vm._v("导 入")])], 1)])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-query"
  }, [_c('div', {
    staticClass: "rt-query__container"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "rt-query__collapse"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rows > 2),
      expression: "rows>2"
    }],
    attrs: {
      "icon": _vm.icon,
      "title": _vm.hintMessage
    },
    on: {
      "click": _vm.handleCollapse
    }
  })], 1)], 2), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40,
      "type": "flex"
    }
  }, [_c('el-col', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "rt-query__reset",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 604:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-grid"
  }, [_c('div', {
    staticClass: "rt-grid__header"
  }, [(_vm.$slots.toolbar) ? _c('rt-toolbar', [_vm._t("toolbar")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.more) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-left": "20px",
      "padding": "0 10px",
      "height": "26px",
      "margin-top": "6px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleCollapse
    }
  }, [_c('i', {
    class: _vm.iconClass,
    staticStyle: {
      "font-size": "10px"
    }
  }), _vm._v("\n            更多筛选\n        ")]) : _vm._e(), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "float": "right",
      "width": "20%",
      "margin-top": "6px"
    },
    attrs: {
      "placeholder": _vm.quicksearchPlaceholder
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleQuickSearch($event)
      }
    },
    model: {
      value: (_vm.quickSearch),
      callback: function($$v) {
        _vm.quickSearch = $$v
      },
      expression: "quickSearch"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "-12px"
    },
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.handleQuickSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$slots.more && _vm.showHidden),
      expression: "$slots.more && showHidden"
    }],
    staticClass: "rt-grid__moresearch",
    attrs: {
      "id": "grid__moresearch"
    }
  }, [_vm._t("more"), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40,
      "type": "flex"
    }
  }, [_c('el-col', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "rt-query__reset",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("查询")])], 1)], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "rt-grid__body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "rt-grid__footer"
  }, [(_vm.showPagination) ? _c('el-pagination', {
    attrs: {
      "current-page": _vm.pageIndex,
      "page-size": _vm.pageSize,
      "page-sizes": _vm.pageSizes,
      "layout": _vm.layout,
      "total": _vm.totalRecord
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleIndexChange
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-toolbar"
  }, [_vm._t("default"), _vm._v(" "), (_vm.showBack || _vm.showAutoback) ? [_c('div', {
    staticClass: "rt-divider"
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleBackClick
    }
  }, [_vm._v("返回")])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "rt-nav-item",
    class: {
      "is-active": _vm.active, "is-disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleItemClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 608:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "size": "auto",
      "title": "流程提交",
      "close-on-click-modal": false,
      "before-close": _vm.handleClose,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "rt-flowsubmit-dialog"
  }, [_c('h2', [_vm._v("选择签核流程\n      "), _c('span', [_vm._v("(下拉框中可能存在多个可选项目,请注意选择合适的流程)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('el-select', {
    model: {
      value: (_vm.selectedFlowId),
      callback: function($$v) {
        _vm.selectedFlowId = $$v
      },
      expression: "selectedFlowId"
    }
  }, _vm._l((_vm.flowList), function(flow) {
    return _c('el-option', {
      key: flow.new_flowid,
      attrs: {
        "value": flow.new_flowid,
        "label": flow.new_name
      }
    })
  }))], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h2', [_vm._v("选择签核用户\n        "), _c('span', [_vm._v("(下拉框中可能存在多个可选人员,请注意选择合适的下一级呈递人)")])]), _vm._v(" "), (_vm.stepList != null && _vm.stepList.length > 0) ? _vm._l((_vm.stepList), function(step) {
    return _c('div', {
      key: step.new_flowstepsid
    }, [_c('br'), _vm._v(" "), _c('h3', [_vm._v(_vm._s(step.new_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-select', {
      model: {
        value: (step.selectedUserId),
        callback: function($$v) {
          _vm.$set(step, "selectedUserId", $$v)
        },
        expression: "step.selectedUserId"
      }
    }, _vm._l((step.new_stepusers), function(user) {
      return _c('el-option', {
        key: user.systemuserid,
        attrs: {
          "value": user.systemuserid,
          "label": user.fullname
        }
      })
    }))], 1)
  }) : _c('div', {
    staticStyle: {
      "height": "100px",
      "line-height": "100px",
      "text-align": "center",
      "color": "#888888"
    }
  }, [_vm._v("\n          无审批步骤\n      ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.canSubmit) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmiting
    },
    on: {
      "click": _vm.submitFlow
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关闭")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-content",
    class: {
      'with-side': _vm.$slots.side
    }
  }, [(_vm.$slots.side) ? _c('div', {
    staticClass: "rt-content__side",
    style: (_vm.sideStyle)
  }, [_vm._t("side")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rt-content__main",
    attrs: {
      "id": "contentMain"
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-lookup"
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.lookupValue.name),
      callback: function($$v) {
        _vm.$set(_vm.lookupValue, "name", $$v)
      },
      expression: "lookupValue.name"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.showLookupDialog
    },
    slot: "suffix"
  })]), _vm._v(" "), _c('rt-lookup-dialog', {
    ref: "lookupDialog",
    attrs: {
      "entity": _vm.entity,
      "request-url": _vm.dialogRequestUrl,
      "name-field": _vm.nameField,
      "id-field": _vm.idField,
      "display-fields": _vm.dialogDisplayFields,
      "orderby-fields": _vm.dialogOrderbyFields,
      "custom-conditions": _vm.dialogCustomConditions,
      "filter-fields": _vm.dialogFilterFields
    },
    on: {
      "data-selected": _vm.handleDataSelected
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 611:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rtportal"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packages_header_src_main__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packages_header_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__packages_header_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__packages_content_src_main__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__packages_content_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__packages_content_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__packages_toolbar_src_main__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__packages_toolbar_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__packages_toolbar_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__packages_query_src_main__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__packages_query_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__packages_query_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packages_grid_src_main__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packages_grid_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__packages_grid_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__packages_picklist_src_main__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__packages_picklist_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__packages_picklist_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__packages_button_src_main__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__packages_button_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__packages_button_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__packages_section_src_main__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__packages_section_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__packages_section_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__packages_nav_src_nav__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__packages_nav_src_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__packages_nav_src_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__packages_nav_src_nav_item__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__packages_nav_src_nav_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__packages_nav_src_nav_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__packages_lookup_src_lookup__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__packages_lookup_src_lookup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__packages_lookup_src_lookup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__packages_lookup_src_lookup_dialog__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__packages_lookup_src_lookup_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__packages_lookup_src_lookup_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__packages_excel_import_src_excel_import_dialog__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__packages_excel_import_src_excel_import_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__packages_excel_import_src_excel_import_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__packages_excel_import_src_excel_import__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__packages_excel_import_src_excel_import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__packages_excel_import_src_excel_import__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__packages_flow_src_submit_dialog__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__packages_flow_src_submit_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__packages_flow_src_submit_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__packages_approval_src_progress__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__packages_approval_src_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__packages_approval_src_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__packages_approval_src_progress_dialog__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__packages_approval_src_progress_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__packages_approval_src_progress_dialog__);












//Lookup


//Excel导入


//流程提交

//审批进度



var components = [
    __WEBPACK_IMPORTED_MODULE_1__packages_header_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_2__packages_content_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_3__packages_toolbar_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_4__packages_query_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_5__packages_grid_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_6__packages_picklist_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_7__packages_button_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_8__packages_section_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_9__packages_nav_src_nav___default.a,
    __WEBPACK_IMPORTED_MODULE_10__packages_nav_src_nav_item___default.a,
    __WEBPACK_IMPORTED_MODULE_11__packages_lookup_src_lookup___default.a,
    __WEBPACK_IMPORTED_MODULE_12__packages_lookup_src_lookup_dialog___default.a,
    __WEBPACK_IMPORTED_MODULE_13__packages_excel_import_src_excel_import_dialog___default.a,
    __WEBPACK_IMPORTED_MODULE_14__packages_excel_import_src_excel_import___default.a,
    __WEBPACK_IMPORTED_MODULE_15__packages_flow_src_submit_dialog___default.a,
    __WEBPACK_IMPORTED_MODULE_16__packages_approval_src_progress___default.a,
    __WEBPACK_IMPORTED_MODULE_17__packages_approval_src_progress_dialog___default.a
];

/* harmony default export */ __webpack_exports__["a"] = ({
    install: function (Vue, opts) {

        components.map(function (component) {
            Vue.component(component.name, component);
        });
    }
});

/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(149);
module.exports = __webpack_require__(229);


/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__privilege__ = __webpack_require__(158);






var LOGIN_URL = '../token';

var REFRESH_TOKEN_URL = '../token';

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    var that = this;

    Vue.http.interceptors.request.use(function (config) {
      var accessToken = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.auth.accessToken || "";
      if (accessToken.length > 0) {
        config.headers.Authorization = 'Bearer ' + accessToken;
      }
      return config;
    }, function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });

    Vue.http.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      if (that._isInvalidToken(error.response)) {
        return that._refreshToken(error.config);
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });

    Vue.prototype.$auth = Vue.auth = this;
  },
  login: function login(creds, redirect) {
    var _this = this;

    var data = "grant_type=password&username=" + creds.username + "&password=" + creds.password + "&captcha1=" + creds.captcha1 + "&captcha2=" + creds.captcha2;
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(LOGIN_URL, data).then(function (response) {
      _this._storeToken(response);

      if (redirect) {
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
          name: redirect
        });
      }

      return response.data;
    });
  },
  clearAllData: function clearAllData() {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('CLEAR_ALL_DATA');
    __WEBPACK_IMPORTED_MODULE_4__privilege__["a" /* default */].reset();
  },
  logout: function logout() {
    this.clearAllData();

    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
      name: 'login'
    });
  },
  _retry: function _retry(config) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.request(config);
  },
  _refreshToken: function _refreshToken(config) {
    var _this2 = this;

    var params = "grant_type=refresh_token&refresh_token=" + __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.auth.refreshToken;

    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(REFRESH_TOKEN_URL, params).then(function (resp) {
      _this2._storeToken(resp);
      return _this2._retry(config);
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
    });
  },
  _storeToken: function _storeToken(response) {
    var auth = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.auth;

    auth.isLoggedIn = true;
    auth.accessToken = response.data.access_token;
    auth.refreshToken = response.data.refresh_token;

    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('UPDATE_AUTH', auth);
  },
  _isInvalidToken: function _isInvalidToken(response) {
    var status = response.status;
    var error = response.statusText;
    return status == 401 && (error == 'invalid_token' || error == 'expired_token');
  }
});

/***/ })

},[619]);


// WEBPACK FOOTER //
// static/js/app.7b0bee813e6bcf569810.js